(() => {
  function connect(root, inputSelector, cardSelector, emptySelector, statusSelector, nameKey) {
    const input = root.querySelector(inputSelector);
    if (!input || input.dataset.vnBound) return;
    input.dataset.vnBound = 'true';
    const cards = [...root.querySelectorAll(cardSelector)];
    const empty = root.querySelector(emptySelector);
    const status = root.querySelector(statusSelector);
    const filter = () => {
      const query = input.value.trim().toLocaleLowerCase();
      let count = 0;
      cards.forEach(card => {
        const matches = (card.dataset[nameKey] || '').toLocaleLowerCase().includes(query);
        card.hidden = !matches;
        if (matches) count++;
      });
      if (empty) empty.hidden = count !== 0;
      if (status) status.textContent = query ? `${count} ${count === 1 ? 'match' : 'matches'}` : '';
    };
    input.addEventListener('input', filter);
    filter();
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-vn-designs]').forEach(root => connect(root, '[data-vn-design-search]', '[data-vn-design-card]', '[data-vn-design-empty]', '[data-vn-design-status]', 'placeName'));
    scope.querySelectorAll('[data-vn-states]').forEach(root => connect(root, '[data-vn-state-search]', '[data-vn-state-card]', '[data-vn-state-empty]', '[data-vn-state-status]', 'stateName'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
